import React, { useEffect } from 'react';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import i18next from "i18next";
import useStyles from "../../style/js-style/components/attributes/AttributeTextFieldInputStyle";
import { get as lodashGet } from "lodash";
import { EDGE_DATE_FORMAT } from "services/common/Constants";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "moment/locale/fr";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/it";
import "moment/locale/nl";
import "moment/locale/pt";

function EADatePicker(props) {
  const { classes } = useStyles();
  const {
    formMethods,
    name,
    isDisabled,
    sxClass,
    onError = () => {},
    isRequired = false,
    onBlur = () => {},
    onFocus = () => {},
    save = () => {},
    autoFocus = false,
    onChangeCustom = null,
    value = null,
    triggerOnContinue = false,
    ...otherProps
  } = props;
  const locale = i18next.language || "en";
  moment.locale(locale);

  const inputRef = React.useRef(null);

  const onChange = (value) => {
    formMethods.setValue(name, value ? moment(value).format(EDGE_DATE_FORMAT) : value);
    onChangeCustom&&onChangeCustom(value ? moment(value).format(EDGE_DATE_FORMAT) : value);
    triggerOnContinue && formMethods.trigger(name);
  };

  // Check de la valeur dès le rendu
  useEffect(() => {
    triggerOnContinue && formMethods.trigger(name);
    // eslint-disable-next-line
  }, [triggerOnContinue]);

  const onDatePickerError = (error, value) => {
    onError(error)
    if (!error) {
      if(isRequired && !value) {
        formMethods.setError(name, {
          type: "datepicker",
          message: "required",
        });
      } else {
        formMethods.clearErrors(name);
      }
      return;
    }
    if (error !== formMethods.formState.errors.expirationDate?.message) {
      formMethods.setError(name, {
        type: "datepicker",
        message: error,
      });
    }
  };

  // Détecte un clic en dehors de l'input date pour fermer l'édition
  useEffect(() => {
    function handleClickOutside(event) {
      if (event.target.closest(".MuiPickersPopper-paper")) return;

      if (inputRef.current && !inputRef.current.contains(event.target)) {
        save();
        onBlur();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [inputRef]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      dateFormats={{ keyboardDate: i18next.t("date.dateFormat") }}
      adapterLocale={locale}
    >
      <DatePicker
        {...otherProps}
        sx={{ m: 0 }}
        toolbarTitle={i18next.t("date.toolbarTitle")}
        value={value || formMethods.getValues(name) || null}
        onChange={onChange}
        onError={onDatePickerError}
        format={EDGE_DATE_FORMAT}
        disabled={isDisabled}
        ref={inputRef}
        renderInput={(renderProps) => (
          <TextField
            {...renderProps}
            inputProps={{
              ...renderProps.inputProps,
              placeholder: i18next.t("date.placeholder"),
            }}
            className={classes.input}
            error={!!lodashGet(formMethods.formState.errors, name)}
            sx={{
              ...sxClass,
              width: '150px',
              '& .MuiFormHelperText-root': {
                position: 'absolute',
                bottom: '-18px',
                left: '-10px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              },
            }}
            disabled={isDisabled}
            onFocus={onFocus}
            autoFocus={autoFocus}
            fullWidth
            helperText={
              !!lodashGet(formMethods.formState.errors, name)
                ? i18next.t(
                    `${lodashGet(formMethods.formState.errors, name).message}`
                  )
                : ""
            }
          />
        )}
      />
    </LocalizationProvider>
  );
}

export default EADatePicker;
